// @flow
import { handleResponseOld, makeGet, makePatch /*, makePost */ } from './helpers';
import { getImageUrl } from '../../utils/urls';

const transformConversations = ({ error, meta, payload }) => {
    const transformedPayload = Array.isArray(payload)
        ? payload.map((conv: Object) => {
              const { id, logoUrl, name } = conv.participants.find(p => p.type === 'house');
              let imageUrl =
                  getImageUrl({
                      catalogId: conv.catalogId,
                      imageNumber: 1,
                      itemId: conv.lotId,
                      sellerId: id,
                      width: 100,
                  }) || '';

              return {
                  catalogId: conv.catalogId,
                  conversationId: conv.conversationId,
                  folderId: conv.folderId,
                  imageUrl,
                  itemId: conv.lotId,
                  logoUrl,
                  messageCount: conv.messageCount,
                  read: conv.read,
                  sellerId: id,
                  sender: name,
                  subject: conv.subject,
                  tsLastMessageSent: conv.tsLastMessageSent,
                  type: 'house',
              };
          })
        : payload;

    return {
        error,
        meta,
        payload: transformedPayload,
    };
};

type FetchConversationParams = {
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
};

type FetchConversationsParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    query?: Object,
};

type ConversationActionsParams = {
    authToken: string,
    bidderId: number,
    conversations: number[],
    deployment: string,
    folderId?: number,
};

export default {
    archiveConversation: ({ authToken, bidderId, conversations, deployment }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePatch({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            });
            request.send(
                conversations.map(id => ({
                    id: Number(id),
                    op: 'replace',
                    path: `/folder/id`,
                    value: -1,
                }))
            );
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),
    fetchConversation: ({ authToken, bidderId, conversationId, deployment }: FetchConversationParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            });
            request.query({ conversationId });
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),

    fetchConversations: ({ authToken, bidderId, deployment, query = {} }: FetchConversationsParams) =>
        new Promise<any>((resolve, reject) => {
            const requestQuery = { ...query };
            const options = {
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            };
            if (query.search) {
                options.path = `<MESSAGING-API>bidders/${bidderId}/conversations/search`;
                requestQuery.q = requestQuery.search;
                delete requestQuery.search;
            }
            const request = makeGet(options);

            request.query(requestQuery);

            request.query(query);
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),

    markConversationRead: ({ authToken, bidderId, conversations, deployment }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePatch({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            });
            request.send(
                conversations.map(id => ({
                    id: Number(id),
                    op: 'replace',
                    path: `/read`,
                    value: true,
                }))
            );
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),

    markConversationUnread: ({ authToken, bidderId, conversations, deployment }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePatch({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            });
            request.send(
                conversations.map(id => ({
                    id: Number(id),
                    op: 'replace',
                    path: `/read`,
                    value: false,
                }))
            );
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),
    moveConversation: ({ authToken, bidderId, conversations, deployment, folderId = 0 }: ConversationActionsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePatch({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/conversations`,
            });
            request.send(
                conversations.map(id => ({
                    id: Number(id),
                    op: 'replace',
                    path: `/folder/id`,
                    value: folderId,
                }))
            );
            request.end((err, response) =>
                handleResponseOld({ err, reject, resolve, response, transform: transformConversations })
            );
        }),
};
